import PropTypes from 'prop-types';

function Answer({ option, questionIndex, answers, handleAnswer }) {
    // On initialise la variable qui permet de savoir si l'option est sélectionnée
    const checked = answers[`q${questionIndex}`] === option.type;

    // On définit quel icon utiliser en fonction du type de réponse
    let icon;
    let label;
    switch (option.type) {
        case "politique":
            icon = <AnswerSvgCircle />;
            label = "forme ronde";
            break;
        case "festive":
            icon = <AnswerSvgTriangle />;
            label = "forme triangulaire";
            break;
        default:
            icon = <AnswerSvgSquare />;
            label = "forme carré";
    }

    // Ajout de l'état is-checked dans le groupe en fonction de la réponse
    let groupClass = "answer-group input-group input-group--radio";
    if(checked) {
        groupClass += " is-checked";
    }

    return (
        <div role="listitem" className={groupClass}>
            <input
                className="sr-only"
                type="radio"
                id={"answer--" + String(option.id)}
                name={"q" + (questionIndex + 1)}
                value={option.type}
                data-type={option.type}
                checked={checked}
                onChange={() => handleAnswer(option.type)}
            />
            <div
                aria-hidden="true"
                className={
                    checked ? "answer-radio__emulator is-checked" : "answer-radio__emulator"
                }
                onClick={() => handleAnswer(option.type)}>
                {icon}
            </div>
            <label htmlFor={"answer--" + String(option.id)}>
                <span className="sr-only">{label}</span>
                {option.label}
            </label>
        </div>
    )
}

Answer.propTypes = {
    option: PropTypes.object.isRequired,
    questionIndex: PropTypes.number.isRequired,
    answers: PropTypes.object.isRequired,
    handleAnswer: PropTypes.func.isRequired
}

export default Answer;

function AnswerSvgSquare() {
    return (
        <svg id="Answer_square" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 40 40" width="40" height="40">
            <rect id="Square" fill="none" stroke="#000" strokeMiterlimit="10" strokeWidth="2px" x="3" y="3" width="34" height="34"/>
        </svg>
    )
}

function AnswerSvgCircle() {
    return (
        <svg id="Answer_circle" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 40 40" width="40" height="40">
            <circle id="Circle" fill="none" stroke="#000" strokeMiterlimit="10" strokeWidth="2px" cx="20" cy="20" r="17"/>
        </svg>
    )
}

function AnswerSvgTriangle() {
    return (
        <svg id="Answer_triangle" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 40 40" width="40" height="40">
            <path id="Triangle" fill="none" stroke="#000" strokeMiterlimit="10" strokeWidth="2px" d="M20,4l17,32H3L20,4Z"/>
        </svg>
    )
}
